const languagesArray = ['th-th', 'zh', 'ja', 'ko', 'zh-hk', 'zh-tw', 'ug-cn'];

const generatedIds = new Set(); // 用于存储已生成的ID

const generateRandomId = (index) => {
  index = index + '';

  let id = Math.floor(Math.random() * 1000000000); // 生成一个0到999999999之间的随机整数
  if (generatedIds.has(id)) {
    id = Date.now() + id;
  }
  generatedIds.add(id); // 将新生成的ID添加到集合中
  return Number(id + index);
};

export const setOriginalSubtitleRestructure = (original = [], textNum = 6, language = 'en') => {
  if (original?.length === 0) {
    return [];
  }
  const isChineseOrJapaneseOrKorean = languagesArray.includes(language);
  original.forEach((item) => {
    item.wordSegmented = [];
    const timeLineFrom = item.subtitle.timeLineFrom; // 获取第一个单词的开始时间
    const timeLineTo = item.subtitle.timeLineTo; // 获取最后一个单词的结束时间
    item.wordSegmented = { text: item.subtitle.text, timeLineFrom, timeLineTo }; // 赋值到original.wordSegmented

    // const words = isChineseOrJapaneseOrKorean
    //   ? item.wordSegmented.text.split('')
    //   : item.wordSegmented.text.split(' ');
    let words = [];
    if (item.wordSegmented.text === ' ' || item.wordSegmented.text === '') {
      words = [' '];
    } else {
      words = isChineseOrJapaneseOrKorean
        ? item.wordSegmented.text.split('')
        : item.wordSegmented.text.split(' ');
    }
    const totalDuration = item.wordSegmented.timeLineTo - item.wordSegmented.timeLineFrom; // 计算总时长
    const durationPerWord = totalDuration / words.length; // 计算每个词的平均时长（毫秒）
    item.wordSegmented = words.map((word, index) => {
      const timeLineFrom = item.wordSegmented.timeLineFrom + durationPerWord * index; // 计算每个词的开始时间（四舍五入到毫秒）
      const timeLineTo = timeLineFrom + durationPerWord; // 计算每个词的结束时间（四舍五入到毫秒）
      return {
        id: generateRandomId(index),
        subtitleId: item.subtitle.id, // 添加时间戳id
        text: word,
        timeLineFrom: Math.floor(timeLineFrom),
        timeLineTo: Math.floor(timeLineTo),
      };
    });
    // item.wordSegmented = item.wordSegmented.reduce((acc, word) => {
    //   if (/^[,.!?;：；、。！？，]$/.test(word.text) && acc.length > 0) {
    //     acc[acc.length - 1].text += word.text; // 合并标点符号到上一个item
    //     acc[acc.length - 1].timeLineTo = word.timeLineTo; // 更新结束时间
    //   } else {
    //     acc.push(word); // 添加新词
    //   }
    //   return acc;
    // }, []);
    console.log(item.wordSegmented, 'item.wordSegmenteditem.wordSegmented');
    let currentLine = [];
    let currentId = null;
    let currentSubtitleId = null;
    let currentCount = 0;
    item.subtitleSegmented = [];
    let newtimeLineFrom = item.timeLineFrom;
    let newtimeLineTo = item.timeLineTo;
    console.log(item.wordSegmented);
    item.wordSegmented.forEach((word) => {
      const textLength = word.text.length; // 计算有效字符数（不包括标点符号）
      if (currentLine.length <= 0 && currentCount + textLength >= textNum) {
        item.subtitleSegmented.push({
          id: word.id,
          subtitleId: word.subtitleId,
          text: word.text.trim(),
          timeLineFrom: word.timeLineFrom, // 注入开始时间
          timeLineTo: word.timeLineTo, // 注入结束时间
        }); // 添加当前行到words
        newtimeLineFrom = word.timeLineTo;
      } else {
        if (currentCount + textLength > textNum) {
          item.subtitleSegmented.push({
            id: word.id, // 使用当前行的ID
            subtitleId: currentSubtitleId, // 使用当前行的字幕ID
            text: isChineseOrJapaneseOrKorean ? currentLine.join('') : currentLine.join(' '), // 去掉末尾的空格
            timeLineFrom: newtimeLineFrom, // 注入开始时间
            timeLineTo: newtimeLineTo, // 注入结束时间
          }); // 添加当前行到words
          currentLine = [word.text]; // 重新开始新行

          // currentCount = word.text.length; // 重置字符计数
          currentCount = isChineseOrJapaneseOrKorean ? textLength : textLength + 1; // 重置字符计数
          newtimeLineFrom = word.timeLineFrom; // 更新开始时间
          newtimeLineTo = word.timeLineTo; // 更新结束时间
        } else {
          currentCount += isChineseOrJapaneseOrKorean
            ? textLength
            : currentCount + textLength + 1 > textNum
              ? textLength
              : textLength + 1; // 更新字符计数
          currentLine.push(word.text); // 拼接当前词
          currentId = word.id; // 更新当前ID
          currentSubtitleId = word.subtitleId; // 更新当前字幕ID
          newtimeLineTo = word.timeLineTo; // 更新结束时间
        }
      }
    });
    if (currentLine.length > 0) {
      item.subtitleSegmented.push({
        id: currentId, // 添加时间戳id
        subtitleId: currentSubtitleId,
        text: isChineseOrJapaneseOrKorean ? currentLine.join('') : currentLine.join(' '),
        timeLineFrom: newtimeLineFrom, // 注入开始时间
        timeLineTo: newtimeLineTo, // 注入结束时间
      }); // 添加最后一行
    }
    item.subtitleSegmented.forEach((newWord, newWordIndex) => {
      const leadingPunctuation = newWord.text.match(/^([，。！？；：、“”‘’《》【】…·,])/g) || [];
      const leadingPunctuationString = leadingPunctuation[0] || ''; // 只取第一个匹配的标点符号
      console.log(leadingPunctuationString, 'leadingPunctuationStringleadingPunctuationString');

      if (leadingPunctuationString.length > 0 && newWordIndex > 0) {
        item.subtitleSegmented[newWordIndex - 1].text += leadingPunctuationString; // 合并到上一句话
        newWord.text = newWord.text.replace(/^([，。！？；：、“”‘’《》【】…·,])/, ''); // 去掉句子开头的第一个标点符号
      }
      if (newWord.text === '') {
        item.subtitleSegmented.splice(newWordIndex, 1); // 删除当前的newWord
      }
    });
    delete item.wordSegmented;
  });
  console.log(original, 'originaloriginal123123');
  return original;
};

export const setBilingualSubtitleRestructure = (
  original = [],
  bilingual = [],
  textNum = 60,
  originalLanguage = 'en',
  bilingualLanguage = 'zh',
) => {
  if (original?.length === 0 || bilingual?.length === 0) {
    return { original, bilingual };
  }
  const bilingualIsChineseOrJapaneseOrKorean = languagesArray.includes(bilingualLanguage);
  bilingual.forEach((item) => {
    item.wordSegmented = [];
    item.subtitleSegmented = [];
    const timeLineFrom = item.subtitle.timeLineFrom; // 获取第一个单词的开始时间
    const timeLineTo = item.subtitle.timeLineTo; // 获取最后一个单词的结束时间
    item.wordSegmented = { text: item.subtitle.text, timeLineFrom, timeLineTo }; // 赋值到original.wordSegmented
    // const words = bilingualIsChineseOrJapaneseOrKorean
    //   ? item.wordSegmented.text.split('')
    //   : item.wordSegmented.text.split(' ');
    let words = [];
    if (item.wordSegmented.text === ' ' || item.wordSegmented.text === '') {
      words = [' '];
    } else {
      words = bilingualIsChineseOrJapaneseOrKorean
        ? item.wordSegmented.text.split('')
        : item.wordSegmented.text.split(' ');
    }

    const totalDuration = item.wordSegmented.timeLineTo - item.wordSegmented.timeLineFrom; // 计算总时长

    const durationPerWord = totalDuration / words.length; // 计算每个词的平均时长（毫秒），向下取整
    item.wordSegmented = words.map((word, index) => {
      const timeLineFrom = item.wordSegmented.timeLineFrom + durationPerWord * index; // 计算每个词的开始时间（四舍五入到毫秒）
      const timeLineTo = timeLineFrom + durationPerWord; // 计算每个词的结束时间（四舍五入到毫秒）
      return {
        id: generateRandomId(index), // 添加时间戳id
        subtitleId: item.subtitle.id,
        text: word,
        timeLineFrom: Math.floor(timeLineFrom),
        timeLineTo: Math.floor(timeLineTo),
      };
    });
  });

  const originalIsChineseOrJapaneseOrKorean = languagesArray.includes(originalLanguage);
  original.forEach((item, index) => {
    item.wordSegmented = [];
    item.subtitleSegmented = {};
    const timeLineFrom = item.subtitle.timeLineFrom; // 获取第一个单词的开始时间
    const timeLineTo = item.subtitle.timeLineTo; // 获取最后一个单词的结束时间
    item.wordSegmented = { text: item.subtitle.text, timeLineFrom, timeLineTo }; // 赋值到original.wordSegmented
    // const words = originalIsChineseOrJapaneseOrKorean
    //   ? item.wordSegmented.text.split('')
    //   : item.wordSegmented.text.split(' ');
    let words = [];
    if (item.wordSegmented.text === ' ' || item.wordSegmented.text === '') {
      words = [' '];
    } else {
      words = originalIsChineseOrJapaneseOrKorean
        ? item.wordSegmented.text.split('')
        : item.wordSegmented.text.split(' ');
    }
    const totalDuration = item.wordSegmented.timeLineTo - item.wordSegmented.timeLineFrom; // 计算总时长
    const durationPerWord = totalDuration / words.length; // 计算每个词的平均时长（毫秒）
    item.wordSegmented = words.map((word, wordIndex) => {
      const timeLineFrom = item.wordSegmented.timeLineFrom + durationPerWord * wordIndex; // 计算每个词的开始时间（四舍五入到毫秒）
      const timeLineTo = timeLineFrom + durationPerWord; // 计算每个词的结束时间（四舍五入到毫秒）

      return {
        id: generateRandomId(index), // 添加时间戳id
        subtitleId: item.subtitle.id,
        text: word,
        timeLineFrom: Math.floor(timeLineFrom),
        timeLineTo: Math.floor(timeLineTo),
      };
    });
    let currentLine = [];
    let currentId = null;
    let currentSubtitleId = null;
    let currentCount = 0;
    item.subtitleSegmented = [];
    let newtimeLineFrom = item.timeLineFrom;
    let newtimeLineTo = item.timeLineTo;
    item.wordSegmented.forEach((word) => {
      const textLength = word.text.length; // 计算有效字符数（不包括标点符号）
      if (currentLine.length <= 0 && currentCount + textLength >= textNum) {
        item.subtitleSegmented.push({
          id: word.id,
          subtitleId: word.subtitleId,
          text: word.text.trim(),
          timeLineFrom: word.timeLineFrom, // 注入开始时间
          timeLineTo: word.timeLineTo, // 注入结束时间
        }); // 添加当前行到words
        newtimeLineFrom = word.timeLineTo;
      } else {
        if (currentCount + textLength > textNum) {
          item.subtitleSegmented.push({
            id: word.id, // 使用当前行的ID
            subtitleId: currentSubtitleId, // 使用当前行的字幕ID
            text: originalIsChineseOrJapaneseOrKorean
              ? currentLine.join('')
              : currentLine.join(' '), // 去掉末尾的空格
            timeLineFrom: newtimeLineFrom, // 注入开始时间
            timeLineTo: newtimeLineTo, // 注入结束时间
          }); // 添加当前行到words
          currentLine = [word.text]; // 重新开始新行
          currentCount = originalIsChineseOrJapaneseOrKorean ? textLength : textLength + 1; // 重置字符计数
          newtimeLineFrom = word.timeLineFrom; // 更新开始时间
          newtimeLineTo = word.timeLineTo; // 更新结束时间
        } else {
          currentCount += originalIsChineseOrJapaneseOrKorean
            ? textLength
            : currentCount + textLength + 1 > textNum
              ? textLength
              : textLength + 1; // 更新字符计数
          currentLine.push(word.text); // 拼接当前词
          currentId = word.id; // 更新当前ID
          currentSubtitleId = word.subtitleId; // 更新当前字幕ID
          newtimeLineTo = word.timeLineTo; // 更新结束时间
        }
      }
    });
    if (currentLine.length > 0) {
      item.subtitleSegmented.push({
        id: currentId, // 添加时间戳id
        subtitleId: currentSubtitleId,
        text: originalIsChineseOrJapaneseOrKorean ? currentLine.join('') : currentLine.join(' '),
        timeLineFrom: newtimeLineFrom, // 注入开始时间
        timeLineTo: newtimeLineTo, // 注入结束时间
      }); // 添加最后一行
    }
    item.subtitleSegmented.forEach((newWord, newWordIndex) => {
      const leadingPunctuation = newWord.text.match(/^([，。！？；：、“”‘’《》【】…·,])/g) || [];
      const leadingPunctuationString = leadingPunctuation[0] || ''; // 只取第一个匹配的标点符号
      console.log(leadingPunctuationString, 'leadingPunctuationStringleadingPunctuationString');

      if (leadingPunctuationString.length > 0 && newWordIndex > 0) {
        item.subtitleSegmented[newWordIndex - 1].text += leadingPunctuationString; // 合并到上一句话
        newWord.text = newWord.text.replace(/^([，。！？；：、“”‘’《》【】…·,])/, ''); // 去掉句子开头的第一个标点符号
      }
      if (newWord.text === '') {
        item.subtitleSegmented.splice(newWordIndex, 1); // 删除当前的newWord
      }
    });
    const bilingualSubtitles = item.subtitleSegmented.map((subtitleSegmentedItem) => {
      console.log(subtitleSegmentedItem, bilingual[index].wordSegmented, 'paixu');

      const matchingBilingualItems = bilingual[index].wordSegmented.filter(
        (biItem) =>
          biItem.timeLineFrom >= subtitleSegmentedItem.timeLineFrom &&
          biItem.timeLineFrom <= subtitleSegmentedItem.timeLineTo,
      );
      bilingual[index].wordSegmented = bilingual[index].wordSegmented.filter(
        (biItem) =>
          biItem.timeLineFrom < subtitleSegmentedItem.timeLineFrom ||
          biItem.timeLineFrom > subtitleSegmentedItem.timeLineTo,
      );
      let combinedText;
      if (bilingualIsChineseOrJapaneseOrKorean) {
        combinedText = matchingBilingualItems.map((biItem) => biItem.text).join(''); // 合并符合条件的文本
      } else {
        combinedText = matchingBilingualItems.map((biItem) => biItem.text).join(' '); // 合并符合条件的文本
      }
      console.log(bilingual[index].wordSegmented, 'bilingual[index].wordSegmented');

      return {
        id: matchingBilingualItems.length > 0 ? matchingBilingualItems[0].id : Date.now(),
        subtitleId:
          matchingBilingualItems.length > 0
            ? matchingBilingualItems[0]?.subtitleId
            : bilingual[index]?.id,
        text: combinedText,
        timeLineFrom: subtitleSegmentedItem.timeLineFrom,
        timeLineTo: subtitleSegmentedItem.timeLineTo,
      };
    });

    bilingualSubtitles.forEach((newWord, newWordIndex) => {
      const leadingPunctuation = newWord.text.match(/^([，。！？；：、“”‘’《》【】…·,])/g) || [];
      const leadingPunctuationString = leadingPunctuation[0] || ''; // 只取第一个匹配的标点符号
      console.log(leadingPunctuationString, 'leadingPunctuationStringleadingPunctuationString');

      if (leadingPunctuationString.length > 0 && newWordIndex > 0) {
        bilingualSubtitles[newWordIndex - 1].text += leadingPunctuationString; // 合并到上一句话
        newWord.text = newWord.text.replace(/^([，。！？；：、“”‘’《》【】…·,])/, ''); // 去掉句子开头的第一个标点符号
      }
    });
    bilingual[index].subtitleSegmented = bilingualSubtitles;
    delete item.wordSegmented;
    delete bilingual[index].wordSegmented;
  });

  // original = sortByTimeLineFrom(original);
  // bilingual = sortByTimeLineFrom(bilingual);
  console.log(original, bilingual, '测试数据');
  return { original, bilingual };
};

export const setTranslationTTSRestructure = (
  original = [],
  bilingual = [],
  textNum = 60,
  originalLanguage = 'en',
  bilingualLanguage = 'zh',
) => {
  if (original?.length === 0 || bilingual?.length === 0) {
    return { original, bilingual };
  }
  const originalIsChineseOrJapaneseOrKorean = languagesArray.includes(originalLanguage);
  original.forEach((item) => {
    item.wordSegmented = [];
    item.subtitleSegmented = [];
    const timeLineFrom = item.subtitle.timeLineFrom; // 获取第一个单词的开始时间
    const timeLineTo = item.subtitle.timeLineTo; // 获取最后一个单词的结束时间
    item.wordSegmented = { text: item.subtitle.text, timeLineFrom, timeLineTo }; // 赋值到original.wordSegmented
    // const words = originalIsChineseOrJapaneseOrKorean
    //   ? item.wordSegmented.text.split('')
    //   : item.wordSegmented.text.split(' ');
    let words = [];
    if (item.wordSegmented.text === ' ' || item.wordSegmented.text === '') {
      words = [' '];
    } else {
      words = originalIsChineseOrJapaneseOrKorean
        ? item.wordSegmented.text.split('')
        : item.wordSegmented.text.split(' ');
    }

    const totalDuration = item.wordSegmented.timeLineTo - item.wordSegmented.timeLineFrom; // 计算总时长
    const durationPerWord = totalDuration / words.length; // 计算每个词的平均时长（毫秒），向下取整
    item.wordSegmented = words.map((word, index) => {
      const timeLineFrom = item.wordSegmented.timeLineFrom + durationPerWord * index; // 计算每个词的开始时间（四舍五入到毫秒）
      const timeLineTo = timeLineFrom + durationPerWord; // 计算每个词的结束时间（四舍五入到毫秒）
      return {
        id: generateRandomId(index), // 添加时间戳id
        subtitleId: item.subtitle.id,
        text: word,
        timeLineFrom: Math.floor(timeLineFrom),
        timeLineTo: Math.floor(timeLineTo),
      };
    });
  });
  const bilingualIsChineseOrJapaneseOrKorean = languagesArray.includes(bilingualLanguage);

  bilingual.forEach((item, index) => {
    item.wordSegmented = [];
    item.subtitleSegmented = {};
    const timeLineFrom = item.subtitle.timeLineFrom; // 获取第一个单词的开始时间
    const timeLineTo = item.subtitle.timeLineTo; // 获取最后一个单词的结束时间
    item.wordSegmented = { text: item.subtitle.text, timeLineFrom, timeLineTo }; // 赋值到original.wordSegmented
    let words = [];
    if (item.wordSegmented.text === ' ' || item.wordSegmented.text === '') {
      words = [' '];
    } else {
      words = bilingualIsChineseOrJapaneseOrKorean
        ? item.wordSegmented.text.split('')
        : item.wordSegmented.text.split(' ');
    }

    const totalDuration = item.wordSegmented.timeLineTo - item.wordSegmented.timeLineFrom; // 计算总时长
    const durationPerWord = totalDuration / words.length; // 计算每个词的平均时长（毫秒）
    item.wordSegmented = words.map((word, wordIndex) => {
      const timeLineFrom = item.wordSegmented.timeLineFrom + durationPerWord * wordIndex; // 计算每个词的开始时间（四舍五入到毫秒）
      const timeLineTo = timeLineFrom + durationPerWord; // 计算每个词的结束时间（四舍五入到毫秒）
      return {
        id: generateRandomId(index), // 添加时间戳id
        subtitleId: item.subtitle.id,
        text: word,
        timeLineFrom: Math.floor(timeLineFrom),
        timeLineTo: Math.floor(timeLineTo),
      };
    });
    let currentLine = [];
    let currentId = null;
    let currentSubtitleId = null;
    let currentCount = 0;
    item.subtitleSegmented = [];
    let newtimeLineFrom = item.timeLineFrom;
    let newtimeLineTo = item.timeLineTo;

    item.wordSegmented.forEach((word) => {
      const textLength = word.text.length; // 计算有效字符数
      if (currentLine.length <= 0 && currentCount + textLength >= textNum) {
        item.subtitleSegmented.push({
          id: word.id,
          subtitleId: word.subtitleId,
          text: word.text.trim(),
          timeLineFrom: word.timeLineFrom, // 注入开始时间
          timeLineTo: word.timeLineTo, // 注入结束时间
        }); // 添加当前行到words
        newtimeLineFrom = word.timeLineTo;
      } else {
        if (currentCount + textLength > textNum) {
          item.subtitleSegmented.push({
            id: word.id, // 使用当前行的ID
            subtitleId: currentSubtitleId, // 使用当前行的字幕ID
            text: bilingualIsChineseOrJapaneseOrKorean
              ? currentLine.join('')
              : currentLine.join(' '), // 去掉末尾的空格
            timeLineFrom: newtimeLineFrom, // 注入开始时间
            timeLineTo: newtimeLineTo, // 注入结束时间
          }); // 添加当前行到words
          currentLine = [word.text]; // 重新开始新行

          // currentCount = word.text.length; // 重置字符计数
          currentCount = bilingualIsChineseOrJapaneseOrKorean ? textLength : textLength + 1; // 重置字符计数
          newtimeLineFrom = word.timeLineFrom; // 更新开始时间
          newtimeLineTo = word.timeLineTo; // 更新结束时间
        } else {
          currentCount += bilingualIsChineseOrJapaneseOrKorean
            ? textLength
            : currentCount + textLength + 1 > textNum
              ? textLength
              : textLength + 1; // 更新字符计数
          currentLine.push(word.text); // 拼接当前词
          currentId = word.id; // 更新当前ID
          currentSubtitleId = word.subtitleId; // 更新当前字幕ID
          newtimeLineTo = word.timeLineTo; // 更新结束时间
        }
      }
    });

    if (currentLine.length > 0) {
      item.subtitleSegmented.push({
        id: currentId, // 添加时间戳id
        subtitleId: currentSubtitleId,
        text: bilingualIsChineseOrJapaneseOrKorean ? currentLine.join('') : currentLine.join(' '),
        timeLineFrom: newtimeLineFrom, // 注入开始时间
        timeLineTo: newtimeLineTo, // 注入结束时间
      }); // 添加最后一行
    }
    item.subtitleSegmented.forEach((newWord, newWordIndex) => {
      const leadingPunctuation = newWord.text.match(/^([，。！？；：、“”‘’《》【】…·,])/g) || [];
      const leadingPunctuationString = leadingPunctuation[0] || ''; // 只取第一个匹配的标点符号
      console.log(leadingPunctuationString, 'leadingPunctuationStringleadingPunctuationString');

      if (leadingPunctuationString.length > 0 && newWordIndex > 0) {
        item.subtitleSegmented[newWordIndex - 1].text += leadingPunctuationString; // 合并到上一句话
        newWord.text = newWord.text.replace(/^([，。！？；：、“”‘’《》【】…·,])/, ''); // 去掉句子开头的第一个标点符号
      }
      console.log(newWord, 'newWordnewWordnewWord');

      if (newWord.text === '') {
        item.subtitleSegmented.splice(newWordIndex, 1); // 删除当前的newWord
      }
    });
    const originalSubtitles = item.subtitleSegmented.map((subtitleSegmentedItem) => {
      const matchingBilingualItems = original[index].wordSegmented.filter(
        (biItem) =>
          biItem.timeLineFrom >= subtitleSegmentedItem.timeLineFrom &&
          biItem.timeLineFrom <= subtitleSegmentedItem.timeLineTo,
      );
      original[index].wordSegmented = original[index].wordSegmented.filter(
        (biItem) =>
          biItem.timeLineFrom < subtitleSegmentedItem.timeLineFrom ||
          biItem.timeLineFrom > subtitleSegmentedItem.timeLineTo,
      );
      let combinedText;
      if (originalIsChineseOrJapaneseOrKorean) {
        combinedText = matchingBilingualItems.map((biItem) => biItem.text).join(''); // 合并符合条件的文本
      } else {
        combinedText = matchingBilingualItems.map((biItem) => biItem.text).join(' '); // 合并符合条件的文本
      }

      return {
        id: matchingBilingualItems.length > 0 ? matchingBilingualItems[0].id : Date.now(),
        subtitleId:
          matchingBilingualItems.length > 0
            ? matchingBilingualItems[0]?.subtitleId
            : bilingual[index]?.id,
        text: combinedText,
        timeLineFrom: subtitleSegmentedItem.timeLineFrom,
        timeLineTo: subtitleSegmentedItem.timeLineTo,
      };
    });
    originalSubtitles.forEach((newWord, newWordIndex) => {
      const leadingPunctuation = newWord.text.match(/^([，。！？；：、“”‘’《》【】…·,])/g) || [];
      const leadingPunctuationString = leadingPunctuation[0] || ''; // 只取第一个匹配的标点符号
      console.log(leadingPunctuationString, 'leadingPunctuationStringleadingPunctuationString');

      if (leadingPunctuationString.length > 0 && newWordIndex > 0) {
        originalSubtitles[newWordIndex - 1].text += leadingPunctuationString; // 合并到上一句话
        newWord.text = newWord.text.replace(/^([，。！？；：、“”‘’《》【】…·,])/, ''); // 去掉句子开头的第一个标点符号
      }
    });
    original[index].subtitleSegmented = originalSubtitles;
    delete item.segmentedSubtitles;
    delete item.wordSegmented;
    delete original[index].wordSegmented;
  });
  console.log();
  return { original, bilingual };
};
